import { firebase } from '../config/configureFirebase';

export const RequestPushMsg = (token, data) => {
    const {
        config
    } = firebase;
    
    // CORS fix: prefer same-origin (panel custom domain -> Hosting rewrite -> function).
    let host = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/send_notification`;

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    })
    .then((response) => {

    })
    .catch((error) => {
        console.log(error)
    });
}